import { GraphBreadcrumbs } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbs';
import type { FC } from 'react';

export const GraphTopControls: FC = () => (
  <div className='graph-top-controls'>
    <GraphBreadcrumbs />
  </div>
);
